"use client"

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"

const faqs = [
  {
    question: "Can you certify my organization as HIPAA compliant?",
    answer:
      "There is no official HIPAA certification. Unlike PCI-DSS or SOC 2, HIPAA has no governing body that grants certifications\u2014every organization is essentially self-certifying their compliance. What we provide is a comprehensive compliance report documenting that your organization follows HIPAA guidelines, which you can use to demonstrate compliance to auditors, business partners, and patients.",
  },
  {
    question: "Who needs to be HIPAA compliant?",
    answer:
      "Any organization that handles Protected Health Information (PHI) must comply with HIPAA. This includes healthcare providers, health plans, healthcare clearinghouses, and their business associates (vendors, contractors, and service providers).",
  },
  {
    question: "How long does the assessment take?",
    answer:
      "The assessment typically takes 10-15 minutes to complete. You'll answer 60 questions covering administrative, physical, and technical safeguards. Results are provided instantly.",
  },
  {
    question: "What are the January 2025 HIPAA updates?",
    answer:
      "The January 2025 Security Rule updates mandate multi-factor authentication (MFA) for electronic PHI access, enhanced encryption requirements for data at rest and in transit, faster breach notification (72 hours), and more comprehensive risk analysis documentation.",
  },
  {
    question: "What happens if I'm not compliant?",
    answer:
      "Non-compliance can result in penalties ranging from $137 to $2,067,813 per violation annually, depending on the severity and whether willful neglect is involved. Beyond fines, breaches can damage reputation, result in lawsuits, and lead to loss of patient trust.",
  },
  {
    question: "Is this assessment confidential?",
    answer:
      "Absolutely. Your assessment responses are completely confidential and encrypted. We never share your information with third parties. The assessment is designed to help you identify gaps, not to report violations.",
  },
  {
    question: "Do I need technical expertise to complete this?",
    answer:
      "No technical expertise is required. Questions are written in plain language, and we provide context and examples throughout. If you're unsure about any question, you can select \"Not Sure\" and we'll flag it for review.",
  },
  {
    question: "What's included in the compliance report?",
    answer:
      "Your report includes an overall compliance score, breakdown by safeguard category (Administrative, Physical, Technical), specific gap identification, risk prioritization, and actionable recommendations with implementation timelines.",
  },
  {
    question: "Can this assessment replace a formal risk analysis?",
    answer:
      "This assessment is a screening tool to identify potential compliance gaps and help you understand your readiness. While comprehensive, it should complement\u2014not replace\u2014a formal, documented risk analysis as required by HIPAA.",
  },
]

export function HomeFaq() {
  return (
    <Accordion type="single" collapsible className="space-y-4">
      {faqs.map((faq, index) => (
        <AccordionItem key={index} value={`item-${index}`} className="border rounded-lg px-6 bg-white">
          <AccordionTrigger className="text-left font-bold text-[#0F172A] hover:text-[#0EA5E9]">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="text-[#475569]">{faq.answer}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
